module.exports = __webpack_public_path__ + "img/zz500.c044e7da.png";